// extracted by mini-css-extract-plugin
export default {"quillToolbar":"TextEditor_quillToolbar__svxxG","quillEditingArea":"TextEditor_quillEditingArea__PF-E7","quillPaper":"TextEditor_quillPaper__8W2qz"};